import {Ng2SelectizeModule} from "./ng2-selectize.module";
import {Ng2SelectizeComponent} from "./ng2-selectize.component";

export {Ng2SelectizeModule, Ng2SelectizeComponent};
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
